export default __webpack_public_path__ + "static/media/Angular.1f6dea3d.svg";